import { render, staticRenderFns } from "./select-user-aliaddo.vue?vue&type=template&id=45ef3cef"
import script from "./select-user-aliaddo.vue?vue&type=script&lang=js"
export * from "./select-user-aliaddo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports